import { render, staticRenderFns } from "./NewsletterInput.vue?vue&type=template&id=d815bdc4&scoped=true&"
import script from "./NewsletterInput.vue?vue&type=script&lang=js&"
export * from "./NewsletterInput.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterInput.vue?vue&type=style&index=0&id=d815bdc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d815bdc4",
  null
  
)

export default component.exports